<template>
    <div class="modal fade" :id="'PreviewMealsModal'+plan.name.split(' ')[0]" role="dialog"
          aria-labelledby="PreviewMealsModal"
          data-toggle="modal"
          v-if="plan">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title">{{plan ? plan.name : ''}} for {{format_date(deliveryDate)}} <span
                        v-if="noFish">(fish meals will be substituted by our team before meal creation)</span></h1>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <!--This weeks meals-->
                    <div class="row row-eq-height" v-if="meals">
                        <div class="meal-item col-12 col-lg-4" v-for="meal in meals" :key='meal.id'>
                            <div>
                                <meal-item-preview class="meal-item p-1"
                                                         :deliveryDate="deliveryDate"
                                                         :meals="meals"
                                                         :meal="meal"
                                                         :hideLiking="true"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import MealItemPreview from './MealItemPreview';

    export default {
        components: {MealItemPreview},
        props: ['deliveryDate', 'meals', 'plan', 'noFish'],
        data() {
            return {};
        },
        methods: {
            format_date(date) {
                return moment(date).format('MM-DD-YYYY');
            }
        },
        mounted() {
        }
    };
</script>

<style lang="scss" scoped>

    .modal-dialog {
        overflow-y: initial !important
    }

    .modal-body {
        max-height: calc(100vh - 200px);
        overflow-y: auto;
    }

</style>
